import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { CandlestickTileConfigState } from 'widgets/candlestickTile/store/config/CandlestickTileConfigState';
import { priceStreamedDataSelectors } from 'widgets/candlestickTile/store/stream/streamSlice';
import { useExternalMarketBarDataMessages } from 'marketData/hooks';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

const { useStreamedDataMessages } = priceStreamedDataSelectors;

export function useCandlestickMessagesInMyPortfolioCapsules(
    symbol: string,
    symbology: SymbologyValues
) {
    const { config } =
        useMyPortfolioCapsuleConfigSlice<CandlestickTileConfigState>();

    const streamMessages = useStreamedDataMessages(symbol, config);
    const externalMarketDataMessages = useExternalMarketBarDataMessages(
        symbol,
        symbology,
        config.bucketSize
    );
    return [...streamMessages, ...externalMarketDataMessages];
}
